/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-06 11:44:02
 * @LastEditors: Json Chen
 * @LastEditTime: 2023-04-21 13:23:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductsLinkProduct/service/service.ts
 */
import { useQueryLanguageListContentEditor } from '@/src/constrains/SalesChannelMultiLanguageSelect';
import { isPrimaryLanguage } from '@/src/constrains/SalesChannelMultiLanguageSelect/slice';
import {
  request_deleteProduct,
  request_hideProduct,
  request_saveMulti,
  request_showProduct,
  request_linkProductDetail,
} from '@/src/request/salesChannel/product';
import { randomNumber, scrollIntoView } from '@/src/tools/helper';
import { EnumSalesChannelMultiLanguage } from '@/src/types/server/params';
import _ from 'lodash';
import { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getCurrentSalesChannel } from 'src/constrains/SalesChannelHOC/slice';
import { eForceUpdate } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { currentPrimaryCurrencyCode } from 'src/constrains/SalesChannelMultiCurrencySelect/slice';
import { useGetPageCurrencyList } from 'src/constrains/SalesChannelMultiCurrencySelect/hooks';
import { getTCs } from 'src/request/salesChannel/legal';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { Form } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { collapseId } from 'src/pages/SalesChannelProductsConfig/SalesChannelProductsLinkProduct/Components/ServiceDetail';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import {
  assignPriceToProduct,
  assignVariantToProduct,
  validateLabel,
  validateOptions,
  calculateRrp,
} from '../util';
import useOptionsService from './option.service';
import useProductsService from './product.service';
import { translateVariant } from './util';
import { AppDispatch } from 'src/store';
import {
  fetchSalesChannelProductDetail,
  selectProductDetailData,
  selectProductDetailLoading,
} from 'src/config/SiderConfig/slice/SalesChannelProductSiderConfigSlice';

const convertProductServiceFromServer = (data) => {
  const re = (data || []).reduce((pre, now) => {
    const { productUuid } = now;
    return { ...pre, [productUuid]: now };
  }, {});
  return re;
};
const convertProductServiceFromState = (data) => {
  return Object.keys(data || {}).map((uuid) => {
    const target = data[uuid];
    return {
      ...(target || {}),
      productUuid: uuid,
    };
  });
};
const validateProductService = (data) => {
  let flag = false;
  data.forEach((i) => {
    if (!flag) {
      const productUuid = _.get(i, 'productUuid');
      const serviceDetails = _.get(i, 'serviceDetails') || [];
      if (!flag) {
        serviceDetails.forEach((s) => {
          const options = _.get(s, 'options') || [];
          if (!flag) {
            options.forEach((o) => {
              const value = _.get(o, 'value');
              if (!value) {
                flag = productUuid;
              }
            });
          }
        });
      }
    }
  });
  return flag;
};
const convertProductLogisticsFromServer = (data) => {
  const re = (data || []).reduce((pre, now) => {
    const { productUuid } = now;
    return { ...pre, [productUuid]: now };
  }, {});
  return re;
};
const convertProductLogisticsFromState = (data) => {
  return Object.keys(data || {}).map((uuid) => {
    const target = data[uuid];
    return {
      ...(target || {}),
      productUuid: uuid,
    };
  });
};

function useService() {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const salesChannel = useSelector(getCurrentSalesChannel());
  const { currency: salesChannelCurrency } = salesChannel || {};
  const dispatch = useDispatch<AppDispatch>();

  const primaryCurrencyCode = useSelector(currentPrimaryCurrencyCode());
  const currentLanguage = useQueryLanguageListContentEditor();
  const [hasModified, setHasModified] = useState(false);
  const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());

  const history = useHistory();
  const params: {
    saleChannelUuid: string;
    salesChannelProductUuid: string;
  } = useParams();
  const { saleChannelUuid, salesChannelProductUuid } = params;

  // 触发加载货币列表数据
  useGetPageCurrencyList(saleChannelUuid);

  const [generalInfo, setGeneralInfo] = useState({
    productName: 'Sales Channel Product',
    visible: false,
    salesChannelName: 'Sales Channel',
  } as any);
  const [currencyInfo, setCurrencyInfo] = useState({
    differentCurrency: false,
    fixedRate: false,
    exchangeRate: 1,
  });
  //const [aliases,setAliases]=useState([]);
  const [allPromotionTags, setAllPromotionTags] = useState([]);
  const [optionsForMultiLang, setOptionsForML] = useState<Array<any>>([]);
  const [priamryLangProductService, setPrimaryLanguageProductService] =
    useState<any>({});
  const [productService, setProductService] = useState<any>({});
  const [productLogistics, setProductLogistics] = useState<any>({});
  const [currency, setCurrency] = useState('');
  const [deleteModalVisible, setVisible] = useState(false);
  const [deleteOptionIndex, setOptionIndex] = useState(-1);
  const [addModalVisible, setAddVisible] = useState(false);
  const [termsAndConditionList, setTermsAndConditionsList] = useState([]);
  const [flashSaleProducts, setFlashSaleProducts] = useState([]);
  const [subscriptionBuyProducts, setSubscriptionBuyProducts] = useState([]);
  const prevLanguageRef = useRef(currentLanguage);

  const productDetailData = useSelector(selectProductDetailData);
  const isLoading = useSelector(selectProductDetailLoading) === 'pending';

  const {
    products,
    setProducts,
    // C: createProduct,
    U: updateProduct,
    D: deleteProduct,
  } = useProductsService({ setHasModified });
  //console.log('products', products);
  const {
    options,
    setOptions,
    C: createOption,
    U: updateOption,
    D: deleteOption,
  } = useOptionsService();

  const fetchPrimaryLanguageOptions = async () => {
    if (!isOnPrimaryLanguage) {
      try {
        const multiLanguageParams = {
          [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
          [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
        };

        if (salesChannelProductUuid !== 'null') {
          const response = await request_linkProductDetail(
            saleChannelUuid,
            salesChannelProductUuid,
            multiLanguageParams,
          );
          const salesChannelProduct = _.get(
            response,
            'salesChannelProduct',
            {},
          );
          const { options = [] } = salesChannelProduct;
          return options || [];
        }
      } catch (error) {
        console.error('Error fetching primary language options:', error);
      }
    }
    return [];
  };

  const fetchProductDetails = useCallback(
    async (forceUpdate = true) => {
      dispatch(
        fetchSalesChannelProductDetail({
          saleChannelUuid,
          forceUpdate,
          currentLanguage,
          ...(salesChannelProductUuid &&
            salesChannelProductUuid !== 'null' && {
              salesChannelProductUuid,
            }),
        }),
      );

      try {
        if (!termsAndConditionList.length) {
          const tcRes = await getTCs(saleChannelUuid);
          const summaryList = _.get(tcRes, 'summaryList', []);
          setTermsAndConditionsList(summaryList);
        }
      } catch (error) {
        console.error('Error fetching T&Cs:', error);
      }
    },
    [
      dispatch,
      saleChannelUuid,
      salesChannelProductUuid,
      termsAndConditionList.length,
      currentLanguage,
    ],
  );

  useEffect(() => {
    if (productDetailData && !isLoading) {
      processResponse(productDetailData);
    }
  }, [productDetailData, isLoading]);

  const processResponse = useCallback(
    async (dataFromStore) => {
      if (!dataFromStore) return;

      try {
        const {
          differentCurrency = false,
          exchangeRate = 1,
          fixedRate = false,
          flashSaleProducts = [],
          subscriptionBuyProducts = [],
        } = dataFromStore || {};
        const salesChannelProduct = _.get(
          dataFromStore,
          'salesChannelProduct',
          {},
        );

        const aliases = _.get(dataFromStore, 'aliases', []);
        const currency = _.get(dataFromStore, 'salesChannel.currency', '');

        setFlashSaleProducts(flashSaleProducts || []);
        setSubscriptionBuyProducts(subscriptionBuyProducts || []);

        setCurrencyInfo({ differentCurrency, exchangeRate, fixedRate });
        setCurrency(currency);
        const products = _.get(dataFromStore, 'products') || [];
        const {
          options: dataOptions = [],
          prices = [],
          variants = [],
          productServices,
          productLogisticsMethods,
          allPromotionTags,
          visible = false,
        } = salesChannelProduct || {};

        const productName =
          _.get(salesChannelProduct, 'productName') || 'Sales Channel Product';
        const currentSalesChannelName = _.get(
          dataFromStore,
          'salesChannel.name',
          generalInfo.salesChannelName,
        );
        setGeneralInfo({
          productName,
          visible,
          salesChannelName: currentSalesChannelName,
        });

        let arr = assignPriceToProduct(
          prices || [],
          products || [],
          primaryCurrencyCode,
          differentCurrency,
        );

        arr = assignVariantToProduct(variants || [], arr);

        setProducts(arr);
        const _service = convertProductServiceFromServer(productServices || []);
        setPrimaryLanguageProductService(_service || {});

        if (!options.length)
          setOptions(
            isOnPrimaryLanguage
              ? dataOptions || []
              : await fetchPrimaryLanguageOptions(),
          );

        setOptionsForML(_.cloneDeep(dataOptions || []));

        const _logistics = convertProductLogisticsFromServer(
          productLogisticsMethods || [],
        );

        setProductLogistics(_logistics);
        setProductService(_service || {});

        // Process promotion tags
        const _allPromotionTags = (allPromotionTags || []).map((i, index) => {
          if (index === 0) {
            return {
              ...i,
              name: productName,
            };
          } else {
            const { salesChannelProductUuid } = i;
            const target = aliases.find(
              (i) => i.uuid === salesChannelProductUuid,
            );
            const name = _.get(target, 'productName') || 'Product Name';
            return {
              ...i,
              name,
            };
          }
        });

        setAllPromotionTags(_allPromotionTags || []);
      } catch (error) {
        console.error('Process response error:', error);
      }
    },
    [
      isOnPrimaryLanguage,
      currentLanguage,
      salesChannelProductUuid,
      saleChannelUuid,
      primaryCurrencyCode,
    ],
  );

  useEffect(() => {
    if (prevLanguageRef.current === currentLanguage) {
      return;
    }

    prevLanguageRef.current = currentLanguage;

    fetchProductDetails();
  }, [currentLanguage, fetchProductDetails, hasModified]);

  const batchAddVariant = (option) => {
    const result = products.map((product) => {
      const arr = Array.isArray(product.variant) ? [...product.variant] : [];
      const index = arr.findIndex((i) => i.uuid === option.uuid);
      const select = index !== -1 ? arr[index] : null;
      if (!!select) {
        if (!select.value) {
          arr[index].value = option.values[0];
        }
      } else {
        arr.push({ uuid: option.uuid, value: option.values[0] });
      }
      return {
        ...product,
        variant: arr,
      };
    });
    setProducts(result);
  };

  const batchDeleteVariant = (option) => {
    const result = products.map((product) => {
      const arr = Array.isArray(product.variant) ? [...product.variant] : [];
      const index = arr.findIndex((a) => a.uuid === option.uuid);
      if (index >= 0) arr.splice(index, 1);
      return {
        ...product,
        variant: arr,
      };
    });
    setProducts(result);
  };

  const batchDeleteVariantsValue = (option, value) => {
    const result = products.map((product) => {
      const arr = Array.isArray(product.variant) ? [...product.variant] : [];
      const r = arr.filter(
        (a) => !(a.uuid === option.uuid && a.value === value),
      );
      return {
        ...product,
        variant: r,
      };
    });
    setProducts(result);
  };

  const handleAddOption = () => {
    const option = {
      label: '',
      values: [],
      uuid: randomNumber(),
      labelError: false,
      valuesError: false,
    };
    createOption(option);
    setHasModified(true);
    // batchAddVariant(option);
  };

  const handleDeleteOption = (index: number) => {
    const option = options[index];
    if (Array.isArray(option.values) && option.values.length !== 0) {
      setOptionIndex(index);
    } else {
      delOption(index);
    }
    setHasModified(true);
  };

  const handleHideOptionDelete = () => {
    setHasModified(true);
    setOptionIndex(-1);
  };

  const delOption = (index: number) => {
    setHasModified(true);
    const option = options[index];
    deleteOption(index);
    batchDeleteVariant(option);
    setOptionIndex(-1);
  };

  const handleChangeLabel = (index: number, value: string) => {
    setHasModified(true);
    const option = options[index];
    option.label = value;
    updateOption(index, option);
  };

  const handleAddTag = (index: number, value: string) => {
    const isAllSpace = _.get((value || '').match(/^[ ]*$/), 'index') == 0;
    if (!isAllSpace) {
      setHasModified(true);
      const option = _.cloneDeep(options[index]);
      const { values } = option;
      const valueList = value ? value.split(',') : [];
      if (valueList.length === 1) {
        if (Array.isArray(values)) {
          const validate = values.every((v) => v !== value);
          if (validate) option.values.push(value);
          option.valuesError = !validate;
          option.valuesHelp = !validate
            ? `You have already used the value " ${value} "`
            : '';
        }
        batchAddVariant(option);
        updateOption(index, option);
      } else {
        valueList.map((val) => {
          if (Array.isArray(values)) {
            const validate = values.every((v) => v !== val);
            if (validate) option.values.push(val);
            option.valuesError = !validate;
            option.valuesHelp = !validate
              ? `You have already used the value " ${val} "`
              : '';
          }
        });
        batchAddVariant(option);
        updateOption(index, option);
      }
    }
  };

  const handleDeleteTag = (index: number, valueIndex: number) => {
    setHasModified(true);
    const option = _.cloneDeep(options[index]);
    const { uuid: optionUuid } = option;
    let value;
    if (Array.isArray(option.values)) {
      value = option.values[valueIndex];

      //针对产品已经选了这个值
      const _products = products.map((i) => {
        const { variant } = i;
        const _variant = (variant || []).map((j) => {
          const { uuid, value: _value } = j;

          if (optionUuid === uuid && _value === value) {
            return {
              ...j,
              value: null,
            };
          }
          return j;
        });

        return {
          ...i,
          variant: _variant,
        };
      });
      setProducts(_products);
      option.values.splice(valueIndex, 1);
      const validate = option.values.length !== 0;
      option.valuesError = !validate;
      option.valuesHelp = !validate
        ? getI18nFromGeneral('general.error.optionvaluecannotbeempty')
        : '';
    }
    updateOption(index, option);
    batchDeleteVariantsValue(option, value);
  };

  const handleChangeProductRrp = (index: number, value: string) => {
    setHasModified(true);
    updateProduct(index, {
      ...products[index],
      rrp: value && +value ? +value : null,
    });
  };

  const handleChangeListPrice = (
    index: number,
    uuid: string,
    value: string,
  ) => {
    setHasModified(true);
    const product = products[index];

    // 获取新的价格
    const newPrice = +value;

    // 计算新的RRP值
    const newRrp = calculateRrp(
      product,
      uuid,
      primaryCurrencyCode,
      currencyInfo.differentCurrency,
    );

    // 更新产品状态
    updateProduct(index, {
      ...product,
      price: newPrice,
      listPriceUuid: uuid,
      rrp: newRrp,
    });
  };

  const handleChangeVisibility = async (visible: boolean) => {
    try {
      if (visible) {
        if (salesChannelProductUuid !== 'null') {
          await request_showProduct(salesChannelProductUuid);
          msg.success(getI18n('general.successfullyupdated'));
        }
        setGeneralInfo({ ...generalInfo, visible: true });
      } else {
        if (salesChannelProductUuid !== 'null') {
          await request_hideProduct(salesChannelProductUuid);
          msg.success(getI18n('general.successfullyupdated'));
        }
        setGeneralInfo({ ...generalInfo, visible: false });
      }
    } catch (e) {
      console.log(e, 'error');
    }
  };

  const handleOnAllPromotionTags = (tags) => {
    setHasModified(true);
    setAllPromotionTags(tags || []);
  };

  const handleAddProduct = (selectProduct) => {
    setHasModified(true);
    //console.log('selectProduct', selectProduct);
    if (
      Array.isArray(selectProduct) &&
      selectProduct.length > 0 &&
      (selectProduct[0].productType === 'GiftCard' ||
        selectProduct[0].productType === 'Service')
    ) {
      //virtual
      const product = selectProduct;
      const product1Name = _.get(product[0], 'name');
      setGeneralInfo({ ...generalInfo, productName: product1Name });
      const _selectProduct = selectProduct.map((i) => {
        const existing = products.find((p) => p.uuid === i.uuid);
        if (existing) {
          return existing;
        } else {
          return {
            ...i,
            variant: options.map((o) => ({
              uuid: o.uuid,
              value: o.values[0] || null,
            })),
            price: i.defaultSalePrice || 0,
            listPriceUuid: '1',
            rrp: calculateRrp(
              i,
              '1',
              primaryCurrencyCode,
              currencyInfo.differentCurrency,
            ),
          };
        }
      });

      setProducts(_selectProduct);
      // const removedDuplicatedSelect = selectProduct.filter(
      //   (v) => !products.some((p) => p.uuid === v.uuid),
      // );
      // const result = [
      //   ...products,
      //   ...removedDuplicatedSelect.map((v) => ({
      //     ...v,
      // variant: [],
      // price: v.defaultSalePrice || 0,
      // listPriceUuid: '1',
      // rrp: null,
      //   })),
      // ];
      // console.log('result', result);
      // setProducts(result);
      //productService;

      const service = product.reduce((pre, now) => {
        const { uuid, productType, productService: proService } = now;
        if (productType === 'Service') {
          //   console.log('productService[uuid]', productService[uuid]);
          if (productService[uuid]) {
            return { ...pre, [uuid]: productService[uuid] };
          } else {
            return { ...pre, [uuid]: proService };
          }
        }
        return pre;
      }, {});
      //console.log('service', service);
      setProductService(service); //ok le
      //productLogistics, setProductLogistics
      const logistic = product.reduce((pre, now) => {
        const { uuid, productType } = now;
        if (productType === 'GiftCard') {
          if (productLogistics[uuid]) {
            return { ...pre, [uuid]: productLogistics[uuid] };
          } else {
            return {
              ...pre,
              [uuid]: {
                notify: true,
                emailTemplateUuid: null,
                smsTemplateUuid: null,
              },
            };
          }
        } else {
          if (productLogistics[uuid]) {
            return { ...pre, [uuid]: productLogistics[uuid] };
          } else {
            return {
              ...pre,
              [uuid]: {
                notify: true,
                emailTemplateUuid: null,
                smsTemplateUuid: null,
              },
            };
          }
        }
      }, {});
      setProductLogistics(logistic);
      // request_getVirtualProduct(product.uuid, { requestSourceID: uuid() }).then(
      //   (res) => {
      //     const { productService } = res || ({} as any);
      //setGeneralInfo({ ...generalInfo, productName: product.name });
      // ? [
      // {
      //   ...product,
      //   price: product.defaultSalePrice || 0,
      //   listPriceUuid: '1',
      //   rrp: null,
      // },
      //   ]
      // : [],
      //     setProductService(productService);
      //   },
      // );
    } else {
      //physical

      // const removedDuplicatedSelect = selectProduct.filter(
      //   (v) => !products.some((p) => p.uuid === v.uuid),
      // );
      // const result = [
      //   //...products,
      //   ...removedDuplicatedSelect.map((v) => ({
      //     ...v,
      //     variant: options.map((o) => ({
      //       uuid: o.uuid,
      //       value: o.values[0] || null,
      //     })),
      //     price: v.defaultSalePrice || 0,
      //     listPriceUuid: '1',
      //     rrp: null,
      //   })),
      // ];
      const _selectProduct = selectProduct.map((i) => {
        const existing = products.find((p) => p.uuid === i.uuid);
        if (existing) {
          return existing;
        } else {
          return {
            ...i,
            variant: options.map((o) => ({
              uuid: o.uuid,
              value: o.values[0] || null,
            })),
            price: i.defaultSalePrice || 0,
            listPriceUuid: '1',
            rrp: calculateRrp(
              i,
              '1',
              primaryCurrencyCode,
              currencyInfo.differentCurrency,
            ),
          };
        }
      });
      const product = _selectProduct[0];
      setGeneralInfo({ ...generalInfo, productName: product?.name });
      setProducts(_selectProduct);
    }
  };

  const handleDelete = async () => {
    setHasModified(true);
    try {
      setVisible(false);
      await request_deleteProduct(salesChannelProductUuid);
      msg.success('Product has been deleted');
      handleGoBack({ skipNotice: true });
    } catch (e) {
      console.log(e, 'error');
    }
  };

  const handleChangeVariant = (
    productIndex: number,
    variantIndex: number,
    value: string,
    optionsUuid: string,
  ) => {
    setHasModified(true);
    const product = products[productIndex];
    const variant = product.variant ? [...product.variant] : [];
    //const info = variant[variantIndex];
    variant.splice(variantIndex, 1, { uuid: optionsUuid, value });
    const result = {
      ...product,
      variant,
    };
    updateProduct(productIndex, result);
  };

  const handleMLChangeLabel = (index: number, value: any) => {
    setHasModified(true);
    const newOptions = _.cloneDeep(optionsForMultiLang);
    if (newOptions[index]) {
      newOptions[index].label = value;
    } else {
      newOptions[index] = {
        uuid: options[index]?.uuid,
        label: value,
        values: [],
      };
    }
    setOptionsForML(newOptions);
  };

  const handleMLChangeValue = (
    index: number,
    optionIndex: number,
    value: any,
  ) => {
    setHasModified(true);
    const newOptions = _.cloneDeep(optionsForMultiLang);
    if (newOptions[optionIndex]) {
      if (newOptions[optionIndex]?.values) {
        newOptions[optionIndex].values[index] = value;
      } else {
        newOptions[optionIndex].values = [];
        newOptions[optionIndex].values[index] = value;
      }
    } else {
      newOptions[optionIndex] = {
        uuid: options[optionIndex]?.uuid,
        label: '',
        values: [],
      };
      newOptions[optionIndex].values[index] = value;
    }

    setOptionsForML(newOptions);
  };

  const handleChangePlaceholder = (
    uuid: string,
    index: number,
    value: string,
  ) => {
    const serviceDetails: Array<any> =
      _.cloneDeep(_.get(productService[uuid], 'serviceDetails', [])) || [];
    serviceDetails[index].placeHolder = value;
    setHasModified(true);
    setProductService({
      ...productService,
      [uuid]: { ...(productService[uuid] || {}), serviceDetails },
    });
  };

  const handleChangeServiceOptions = (
    uuid: string,
    serviceIndex: number,
    index: number,
    value: string,
  ) => {
    const serviceDetails: Array<any> =
      _.cloneDeep(_.get(productService[uuid], 'serviceDetails', [])) || [];
    (serviceDetails[serviceIndex].options[index] || {}).value = value;

    setHasModified(true);
    // console.log('a', a);
    setProductService({
      ...productService,
      [uuid]: { ...(productService[uuid] || {}), serviceDetails },
    });
  };

  const handleChangeTitle = (uuid: string, index: number, value: string) => {
    const serviceDetails: Array<any> =
      _.cloneDeep(_.get(productService[uuid], 'serviceDetails', [])) || [];
    serviceDetails[index].title = value;
    setHasModified(true);
    setProductService({
      ...productService,
      [uuid]: {
        ...(productService[uuid] || {}),
        serviceDetails,
      },
    });
  };

  const handleOnDetailsTcChange = (uuid: string, termsConditions: any) => {
    setHasModified(true);
    //console.log(uuid, termsConditions);
    setProductService({
      ...productService,
      [uuid]: { ...(productService[uuid] || {}), termsConditions },
    });
  };

  const handleCloneOptions = () => {
    setHasModified(true);
    if (
      products[0]?.productType === 'GiftCard' ||
      products[0]?.productType === 'Service'
    ) {
      setProductService(_.cloneDeep(priamryLangProductService));
    } else {
      setOptionsForML(_.cloneDeep(options));
    }
  };

  const handleSubmit = async () => {
    // if (false) {
    //   const product = products[0];
    //   const body = {
    //     salesChannelUuid: saleChannelUuid, //
    //     uuid:
    //       salesChannelProductUuid === 'null' ? null : salesChannelProductUuid, //
    //     content: {
    //       //
    //       productName:
    //         salesChannelProductUuid === 'null'
    //           ? product.name
    //           : generalInfo.productName,
    //     },
    //     visible: generalInfo.visible, //
    //     productType: getLinkProductType(product.productType),
    //     productUuid: product.uuid, //
    //     productService:
    //       product.productType !== 'Simple' ? productService : null, //
    //     listPriceUuid:
    //       product.listPriceUuid === '1' ? null : product.listPriceUuid, //
    //     rrp: product.rrp, //
    //   };
    //   const res = await request_saveSingle(body, {
    //     [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
    //     [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
    //   });
    //   msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
    //   setTimeout(
    //     () =>
    //       history.replace(
    //         `/salesChannel/products/link/${saleChannelUuid}/${res.uuid}`,
    //       ),
    //     1000,
    //   );
    //   eForceUpdate(res.uuid);
    // } //暂不执行，无用代码
    if (true) {
      const product = products[0];
      const productServices = convertProductServiceFromState(productService);
      const serviceFlag = validateProductService(productServices);
      if (serviceFlag) {
        scrollIntoView(`${collapseId}-${serviceFlag}`);
        return;
      }
      const body = {
        productServices: productServices,
        productLogisticsMethods:
          convertProductLogisticsFromState(productLogistics),
        salesChannelUuid: saleChannelUuid,
        uuid:
          salesChannelProductUuid === 'null' ? null : salesChannelProductUuid,
        visible: generalInfo.visible,
        //   productType: 'Multiple',
        productUuids: products.map((p) => p.uuid),
        options: isOnPrimaryLanguage
          ? options.map((o) => ({
              uuid: o.uuid,
              label: o.label,
              values: o.values,
            }))
          : optionsForMultiLang.map((o) => ({
              uuid: o.uuid,
              label: o.label,
              values: o.values,
            })),
        content: {
          productName:
            salesChannelProductUuid === 'null'
              ? product.name
              : generalInfo.productName,
        },
        prices: products.map((p) => ({
          productUuid: p.uuid,
          listPriceUuid: p.listPriceUuid === '1' ? null : p.listPriceUuid,
          rrp: p.rrp,
        })),
        variants: products.map((product) => {
          if (product.variant) {
            return {
              productUuid: product.uuid,
              values: translateVariant(
                isOnPrimaryLanguage,
                options,
                optionsForMultiLang,
                [...product.variant],
              ),
            };
          }
        }),
        allPromotionTags,
      } as any;
      if ((products || []).length === 1) {
        body.rrp = products[0].rrp;
      }
      const validateResult = validateOptions(options, products);

      if (validateResult.validate) {
        const res = await request_saveMulti(body, {
          [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
          [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
        });
        msg.success(
          getI18nFromGeneral('general.status.changessavesuccessfully'),
        );
        setTimeout(
          () =>
            history.replace(
              `/salesChannel/products/link/${saleChannelUuid}/${res.uuid}`,
            ),
          1000,
        );
        eForceUpdate(res.uuid);
        setHasModified(false);
        setPrimaryLanguageProductService(
          convertProductServiceFromState(productService) || {},
        );
      } else {
        scrollIntoView('salesChannelLinkProductPrice');
        setOptions(validateResult.options);
        setProducts(validateResult.products);
      }
    }
  };

  const vailidateLabel = (index: string) => {
    const option = validateLabel(index, options[index], options);
    updateOption(index, option);
  };

  const handleShowWarning = () => setVisible(true);

  const handleHideWarning = () => setVisible(false);

  const handleShowAdd = () => setAddVisible(true);

  const handleHide = () => setAddVisible(false);

  const handleGoBack = (state?) => {
    history.push(`/salesChannel/products/${saleChannelUuid}`, state);
  };
  //productLogistics, setProductLogistics
  const handleLogisticNotifyChange = (uuid, notify) => {
    setHasModified(true);
    const obj = productLogistics[uuid] || {};
    const _productLogistics = {
      ...(productLogistics || {}),
      [uuid]: {
        ...obj,
        notify,
      },
    };
    setProductLogistics(_productLogistics);
  };

  const handleLogisticEmailChange = (uuid, emailTemplateUuid) => {
    setHasModified(true);
    const obj = productLogistics[uuid] || {};
    const _productLogistics = {
      ...(productLogistics || {}),
      [uuid]: {
        ...obj,
        emailTemplateUuid,
      },
    };
    setProductLogistics(_productLogistics);
  };

  const handleLogisticSmsChange = (uuid, smsTemplateUuid) => {
    setHasModified(true);
    const obj = productLogistics[uuid] || {};
    const _productLogistics = {
      ...(productLogistics || {}),
      [uuid]: {
        ...obj,
        smsTemplateUuid,
      },
    };
    setProductLogistics(_productLogistics);
  };

  return {
    currencyInfo,
    productService,
    currency,
    optionsForMultiLang,
    isOnPrimaryLanguage,
    deleteOptionIndex,
    salesChannelProductUuid,
    deleteModalVisible,
    addModalVisible,
    generalInfo,
    products,
    options,
    isLoading,
    delOption,
    deleteProduct,
    batchAddVariant,
    batchDeleteVariant,
    handleCloneOptions,
    batchDeleteVariantsValue,
    handleHideOptionDelete,
    setGeneralInfo,
    handleAddProduct,
    handleAddOption,
    handleDeleteOption,
    handleChangeLabel,
    handleAddTag,
    handleDeleteTag,
    handleChangeProductRrp,
    handleMLChangeLabel,
    handleMLChangeValue,
    handleChangeListPrice,
    handleGoBack,
    handleChangeVisibility,
    handleChangeVariant,
    handleDelete,
    handleSubmit,
    handleShowWarning,
    handleHideWarning,
    handleShowAdd,
    handleHide,
    vailidateLabel,
    handleChangePlaceholder,
    handleChangeServiceOptions,
    handleChangeTitle,
    hasModified,
    setHasModified,
    handleOnDetailsTcChange,
    termsAndConditionList,
    salesChannelCurrency,
    productLogistics,
    setProductLogistics,
    handleLogisticNotifyChange,
    handleLogisticEmailChange,
    handleLogisticSmsChange,
    flashSaleProducts,
    subscriptionBuyProducts,
    allPromotionTags,
    handleOnAllPromotionTags,
    form,
  };
}

export { useService };
